import { useQuery } from '@tanstack/react-query';
import { fetchManagerReviewV2Access } from '../../services/managerReviewV2Api';

/** Pilot gate for Manager Review v2, answered by the proxy (lib/managerReviewV2.js). */
export function useManagerReviewV2Access(): { enabled: boolean; live: boolean; loading: boolean; failed: boolean; retry: () => void } {
  const query = useQuery({
    queryKey: ['manager-review-v2-access'],
    queryFn: fetchManagerReviewV2Access,
    staleTime: 5 * 60_000,
    retry: 2,
  });
  return {
    enabled: query.data?.enabled === true,
    live: query.data?.live === true,
    loading: query.isLoading,
    failed: query.isError && !query.data,
    retry: () => { void query.refetch(); },
  };
}
